import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';

export default function Gallery({ v }) {
  if (!v.isGallery) return null;
  return (
    <>
      <div style={{ "flex": "1 1 auto", "minHeight": "0", "position": "relative", "display": "flex", "flexDirection": "column" }}>
        {v.hasItems ? (<>
          {/* De metalen paal zelf. Zie poleStyle in render-vals.js. */}
          <div style={css(v.poleStyle)} />
        </>) : null}
        <div ref={v.galleryScrollRef} onTouchStart={v.onPullStart} onTouchMove={v.onPullMove} onTouchEnd={v.onPullEnd} onTouchCancel={v.onPullEnd} style={{ "flex": "1 1 auto", "minHeight": "0", "overflowY": "auto", "overscrollBehaviorY": "contain", "WebkitOverflowScrolling": "touch", "touchAction": "pan-y", "position": "relative", "zIndex": "1" }}>
          {' '}
          <div style={css(v.pullRowStyle)}>
            {' '}
            <span style={css(v.pullIconStyle)}>
              {' '}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={css(v.pullSpinStyle)}>
                <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
                <path d="M21 4v4h-4" />
              </svg>
              {' '}
            </span>
            {' '}
          </div>
          {' '}
          <div style={css(`min-height:100%;${v.galleryPadStyle ?? ''}`)}>
            {' '}
            {/* Deze 1180 staat ook in logic/board.js, als PAAL_VLAK_MAX: de paal moet
                met dezelfde maat rekenen, anders hangen de krabbels ernaast. Draai je
                aan de een, draai dan ook aan de ander. */}
            <div style={{ "position": "relative", "zIndex": "1", "maxWidth": "1180px", "margin": "0 auto" }}>
              {' '}
              <div style={css(v.gallerySidebarStyle)}>
                {' '}
                {v.showBureaubladIconen ? (
                  <div style={css(v.bureaubladRasterStyle)}>
                    {toList(v.bureaubladIconen).map((p, $index) => (
                      <React.Fragment key={$index}>
                        <button onClick={p?.onClick} title={p?.titel} style={css(p?.tegelStyle)}>
                          <span style={css(p?.vakStyle)}>
                            {/* Twee pictogrammen laten zien wat erin zit in plaats van
                                een tekentje: de krabbel van vandaag en het vel van het
                                gastenboek. */}
                            {p?.preview === 'dag' ? <span style={css(v.bureaubladDagStyle)} />
                              : p?.preview === 'gastenboek' ? <img alt="" src={v.gbThumb} style={css(v.bureaubladVelStyle)} />
                                : <Interp v={p?.teken} />}
                          </span>
                          <span style={css(p?.naamStyle)}><Interp v={p?.naam} /></span>
                        </button>
                      </React.Fragment>
                    ))}
                  </div>
                ) : null}
                {v.showTodayUsers ? (<>
                  {' '}
                  {' '}
                  <div style={{ "display": "flex", "flexDirection": "column", "gap": "9px", "paddingBottom": "9px" }}>
                    <div style={{ "fontSize": "13px", "fontWeight": "600", "color": "var(--tekst-2)" }}>
                      Wie krabbelde vandaag?
                    </div>
                    <div style={{ "display": "grid", "gridTemplateColumns": "repeat(5,1fr)", "gap": "8px" }}>
                      {toList(v.todayUsers).map((t, $index) => (
                        <React.Fragment key={$index}>
                          <button onClick={t?.onOpen} title={t?.title} className="gp-btn" style={css(v.todayFaceStyle)}>
                            {' '}
                            <img alt="" src={t?.avatarUrl} style={css(v.todayFaceImgStyle)} />
                            {' '}
                          </button>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                  {' '}
                </>) : null}
                {' '}
                {/* De programma's op het bureaublad, linksboven. Eén klik opent ze,
                    net als overal elders in de app. */}
                {' '}
              </div>
              {' '}
              <div>
                {' '}
                {v.galleryEmpty ? (<>
                  {' '}
                  <div style={{ "border": "3px dashed var(--rand-stippel)", "borderRadius": "16px", "padding": "60px 24px", "textAlign": "center", "color": "var(--tekst-2)" }}>
                    {' '}
                    <div style={{ "fontSize": "19px", "fontWeight": "600", "marginBottom": "6px" }}>
                      <Interp v={v.emptyTitle} />
                    </div>
                    {' '}
                    <div style={{ "fontSize": "14px" }}>
                      <Interp v={v.emptyBody} />
                    </div>
                    {' '}
                  </div>
                  {' '}
                </>) : null}
                {' '}
                {v.hasItems ? (<>
                  {' '}
                  <div style={{ "minHeight": "420px" }}>
                    {/* Het vlak waar de krabbels op hangen. Elke krabbel staat op
                        zijn eigen plek in plaats van onder de vorige, zodat je hem
                        kunt oppakken en ergens anders neerleggen. */}
                    <div ref={v.wallRef} style={css(v.wallStyle)}>
                      {/* Waar de krabbel die je vasthebt terechtkomt. Staat uit tot
                          je begint te slepen; zie toonDoelvakje in logic/board.js. */}
                      <div ref={v.dropRef} style={css(v.dropSlotStyle)} />
                      {toList(v.galleryItems).map((g, $index) => (
                        <React.Fragment key={$index}>
                          <div ref={g?.noteRef} draggable={false} className="gp-note" style={css(g?.noteStyle)} onMouseDown={g?.onNoteDown} onMouseEnter={g?.onEnter} onMouseLeave={g?.onLeave} onTouchStart={g?.onTouch} onTouchMove={g?.onTouchMove}>
                            {' '}
                            {g?.isStatic ? (<>
                              {' '}
                              <img draggable={false} src={g?.src} alt={g?.alt} onClick={g?.onOpen} onLoad={g?.onImgLoad} style={css(g?.imgStyle)} />
                              {' '}
                            </>) : null}
                            {' '}
                            {g?.isAnim ? (<>
                              {' '}
                              <div onClick={g?.onOpen} style={css(g?.animStyle)} />
                              {' '}
                            </>) : null}
                            {' '}
                            {g?.isNew ? (<>
                              {' '}
                              <span style={css(g?.newStyle)} />
                              {' '}
                            </>) : null}
                            {' '}
                            {g?.showCountBubble ? (<>
                              {' '}
                              <span style={css(g?.likeCountStyle)}>
                                {' '}
                                {g?.showLikeCount ? (<>
                                  {' '}
                                  <svg width="11" height="11" viewBox="0 0 24 24" fill="var(--roze)" stroke="var(--roze)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z" />
                                  </svg>
                                  {' '}
                                  <Interp v={g?.likesCount} />
                                  {' '}
                                </>) : null}
                                {' '}
                                {g?.hasComments ? (<>
                                  {' '}
                                  <svg width="11" height="11" viewBox="0 0 24 24" fill="var(--uit)" stroke="var(--uit)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                  </svg>
                                  {' '}
                                  <Interp v={g?.commentCount} />
                                  {' '}
                                </>) : null}
                                {' '}
                              </span>
                              {' '}
                            </>) : null}
                            {' '}
                            {g?.showInfo ? (<>
                              {' '}
                              <div style={css(g?.infoStyle)}>
                                {' '}
                                <div style={{ "fontWeight": "700" }}>
                                  <Interp v={g?.title} />
                                </div>
                                {' '}
                                <div style={{ "opacity": ".65", "fontSize": "12px", "marginTop": "3px" }}>
                                  <Interp v={g?.author} />
                                </div>
                                {' '}
                                <div style={{ "display": "flex", "gap": "5px", "marginTop": "6px", "flexWrap": "wrap" }}>
                                  {g?.isRequested ? (<>
                                    <span style={{ "display": "inline-flex", "alignItems": "center", "gap": "5px", "background": "var(--groen-vlak)", "color": "var(--groen-ink)", "border": "2px solid var(--groen)", "borderRadius": "999px", "padding": "2px 9px 2px 6px", "fontSize": "11px", "fontWeight": "700" }}>
                                      <span style={{ "fontSize": "11px" }}>
                                        ✉️
                                      </span>
                                      {"Verzoekje ✓\n                      "}
                                    </span>
                                  </>) : null}
                                  {g?.isThemeMatch ? (<>
                                    <span style={{ "display": "inline-flex", "alignItems": "center", "gap": "5px", "background": "var(--geel-vlak)", "color": "var(--geel-ink)", "border": "2px solid var(--geel)", "borderRadius": "999px", "padding": "2px 9px 2px 6px", "fontSize": "11px", "fontWeight": "700" }}>
                                      <span style={{ "fontSize": "11px" }}>
                                        🎨
                                      </span>
                                      <Interp v={g?.themeLabel} />
                                    </span>
                                  </>) : null}
                                </div>
                                {' '}
                              </div>
                              {' '}
                            </>) : null}
                            {' '}
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                  {' '}
                </>) : null}
                {' '}
              </div>
              {' '}
            </div>
            {' '}
          </div>
          {' '}
        </div>
      </div>
    </>
  );
}
